module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "fileType": {
        "type": "string",
        "isOptional": true
      },
      "hidden": {
        "type": "boolean",
        "isOptional": true
      },
      "allowsAnonymousAccess": {
        "type": "boolean",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "file-preview",
    "version": "v2"
  },
  "fileInteraction": {
    "name": "fileinteraction",
    "class": "interaction",
    "properties": {
      "interactionType": [
        "share",
        "download",
        "view"
      ],
      "action": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "file-preview",
    "version": "v2"
  }
};